import { render } from "./DeleteBatch.vue?vue&type=template&id=3af1423b"
import script from "./DeleteBatch.vue?vue&type=script&lang=js"
export * from "./DeleteBatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__